import React from "react"
import { Controller } from "react-hook-form"
import Select from "react-select"
import { FormFeedback, Label } from "reactstrap"

const QwikSelect = ({
  name,
  label,
  options,
  placeholder,
  control,
  isMulti = false,

  required = false,
  rules = {},
}) => {
  const finalRules = {
    ...rules,
    ...(required ? { required: `${label || name} is required` } : {}),
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={finalRules}
      render={({ field, fieldState: { error } }) => (
        <div className="form-group">
          {label && (
            // <Label className="form-label" for={name}>
            //   {label}
            // </Label>

            <Label className="form-label" for={name}>
              {label} {required && <span className="text-danger">*</span>}
            </Label>
          )}

          <div className={error ? "is-invalid" : ""}>
            <Select
              {...field}
              id={name}
              options={options}
              placeholder={placeholder}
              classNamePrefix="select2-selection h-100"
              value={options?.find(opt => opt.value === field.value) || ""}
              onChange={val => field.onChange(val?.value)}
              isMulti={isMulti}
            />
          </div>

          {error && (
            <FormFeedback className="d-block">{error.message}</FormFeedback>
          )}
        </div>
      )}
    />
  )
}

export default QwikSelect
